import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { toggleSwitch, popUpMenuChange } from '../../../actions/index'
import MassClosing from '../../menu/massClosing';

class MassClosingButton extends React.Component{

    handleClick = () => {
        this.props.popUpMenuChange({ show: false });
    }

    render(){   
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} >
                    <MassClosing popUpMenu={true}></MassClosing>
                </div>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        toggleSwitch : toggleSwitch,
        popUpMenuChange : popUpMenuChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(MassClosingButton)
